import { TaskBasicInfo } from './taskBasicInfo';
import { ChangeLogEntry } from './changeLogEntry';

export class Task extends TaskBasicInfo {
  public finalizedStamp!: Date;
  public messageVersion!: string;
  public messageType!: string;
  public messageHeaders!: string;
  public input?: string;
  public output?: string;
  public changeLog!: ChangeLogEntry[];
  public inputUtf8!: string;
  public outputUtf8!: string;
  public mapUtf8!: string;
  public transformUtf8!: string;
  public inputExtension!: string;
  public outputExtension!: string;
  public transformExtension!: string;
  public mapExtension!: string;
}
